import { LayoutLogin } from "../../components";

function LoginPage() {
  return <LayoutLogin />;
}

export default LoginPage;
